module.exports = __webpack_public_path__ + "static/media/Desktop7.b73d430f.jpg";